import { z } from "zod"
import { DeviceClass } from "../service/job-timing"

/** The Alfred screens whose effort is measured. See TaskEffort in the API. */
export const EffortTaskSchema = z.enum([
  "RECEPTION",
  "INSPECTION",
  "ADDON_ORDER",
])
export type EffortTask = z.infer<typeof EffortTaskSchema>

export const TaskEffortPeriodDaysSchema = z.union([
  z.literal(7),
  z.literal(30),
  z.literal(90),
])
export type TaskEffortPeriodDays = z.infer<typeof TaskEffortPeriodDaysSchema>
export const TASK_EFFORT_PERIOD_DAYS: TaskEffortPeriodDays[] = [7, 30, 90]
export const DEFAULT_TASK_EFFORT_PERIOD_DAYS: TaskEffortPeriodDays = 30

/** How a measure spreads over the completed tasks. */
export interface EffortSpread {
  median: number
  p75: number
}

export interface TaskEffortSummaryRow {
  task: EffortTask
  /** Null for every device together. */
  deviceClass: DeviceClass | null
  taskCount: number
  activeSeconds: EffortSpread
  clicksAndTaps: EffortSpread
  keystrokes: EffortSpread
  screensScrolled: EffortSpread
  /** Over the tasks done on a desktop only; null when there were none. */
  pointerDistancePx: EffortSpread | null
}

/**
 * One completed task: the submit or send together with the draft saves
 * before it.
 */
export interface TaskEffortAttempt {
  jobId: string
  storeName: string
  task: EffortTask
  /** Where most of the active time was spent. */
  deviceClass: DeviceClass
  completedAt: string
  activeSeconds: number
  clicks: number
  taps: number
  keystrokes: number
  pointerDistancePx: number
  screensScrolled: number
  alfredUrl: string
  sentryReplayUrl: string | null
}

export interface TaskEffortStats {
  summary: TaskEffortSummaryRow[]
  /** The tasks with the most clicks and taps, most first. */
  heaviestTasks: TaskEffortAttempt[]
}
